export * from './lib/shared-core-local-storage';
